export default __webpack_public_path__ + "static/media/element_49.7b039bf5.avif";